const cronLog = (state = [], action) => {
  switch (action.type) {
    case 'SET_CRON_LOG':
      return action.cron_log
    default:
      return state
  }
}

export default cronLog
